import { initContract } from "@ts-rest/core";
import { CountResponseSchema } from "@common/schemas/count-response.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    ClientTaskPreviewsQuerySchema,
    ClientTaskPreviewsResponseSchema,
    OrganizationTaskListQuerySchema,
    OrganizationTaskListResponseSchema,
    OrganizationTaskThreadUnreadCountsResponseSchema,
    OrganizationTasksQuerySchema,
} from "@common/schemas/organization-task.schema";

const c = initContract();

export const organizationTaskContract = c.router(
    {
        getOrganizationTodoTasksCount: {
            method: "GET",
            path: "/todo/count",
            query: OrganizationTasksQuerySchema,
            responses: {
                200: CountResponseSchema,
                400: ErrorMessageSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        listOrganizationTasks: {
            method: "GET",
            path: "/tasks",
            query: OrganizationTaskListQuerySchema,
            responses: {
                200: OrganizationTaskListResponseSchema,
                400: ErrorMessageSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        listOrganizationTaskThreadUnreadCounts: {
            method: "GET",
            path: "/thread-unread-counts",
            query: OrganizationTaskListQuerySchema,
            responses: {
                200: OrganizationTaskThreadUnreadCountsResponseSchema,
                400: ErrorMessageSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        listClientTaskPreviews: {
            method: "GET",
            path: "/previews",
            query: ClientTaskPreviewsQuerySchema,
            responses: {
                200: ClientTaskPreviewsResponseSchema,
                400: ErrorMessageSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/organization-tasks",
    },
);
